const ITEMS = [
  "Cursor Interceptor",
  "Claude Code Compatible",
  "Aider Agent Skill",
  "Localhost Execution",
  "Dynamic Context Recall",
];

const Row = ({ hidden }) => (
  <div
    className="flex items-center gap-12 whitespace-nowrap"
    aria-hidden={hidden || undefined}
  >
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center gap-12">
        <span>{item}</span>
        <span className="text-ember">&bull;</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  return (
    <div
      data-testid="agents-marquee"
      className="border-b border-seam bg-coal py-4 overflow-hidden"
    >
      <div className="flint-marquee-track gap-12 text-xs font-semibold uppercase tracking-wider text-smoke">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
};
